import { createContext, useContext, type ReactNode } from 'react';
import type { Strategy } from '../types/Strategy';

export interface StrategyContextType {
    strategies: Strategy[];
    /** Warning: Modifying this state directly might desync it from Workspace's active state.
      * This context is primarily for read-access to prevent prop-drilling.
      */
}

export const StrategyContext = createContext<StrategyContextType | undefined>(undefined);

export function useStrategies() {
    const context = useContext(StrategyContext);
    if (!context) {
        throw new Error('useStrategies must be used within a StrategyProvider');
    }
    return context;
}

interface StrategyProviderProps {
    children: ReactNode;
    value: StrategyContextType;
}

export function StrategyProvider({ children, value }: StrategyProviderProps) {
    return (
        <StrategyContext.Provider value={value}>
            {children}
        </StrategyContext.Provider>
    );
}
